export function farloUiSliderFade(element) {
  if (!element) return;

  let flkty;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, () => init());

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  });

  function init() {
    if (flkty) flkty.destroy();

    flkty = new Flickity(element, {
      fade: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      hash: true,
      cellAlign: 'left',
      autoPlay: 4000,
      pauseAutoPlayOnHover: false
    });

    // NAV CLICK → only select slide
    document.querySelectorAll('.title-navigation__nav').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const selector = link.getAttribute('data-selector');
        if (selector) flkty.selectCell(selector);
      });
    });

    // SYNC ACTIVE STATE (single source of truth)
    flkty.on('change', (index) => {
      const activeId = flkty.cells[index].element.id;

      document.querySelectorAll('.title-navigation__cell').forEach(item => {
        item.classList.remove('active');

        const link = item.querySelector('.title-navigation__nav');
        if (link && link.getAttribute('data-selector') === '#' + activeId) {
          item.classList.add('active');
        }
      });
    });

    // Set initial active state
    flkty.on('ready', () => {
      flkty.resize();
      flkty.emitEvent('change', [flkty.selectedIndex]);
    });
  }
}